import React, { useContext, useEffect, useRef, useState } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, IconButton, InputLabel, MenuItem, Select, TextField, Typography, Fab, DialogActions, Tabs, Tab, Autocomplete } from "@mui/material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, ContactSupportOutlined, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS, ROLES } from "../../constants";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { all } from "axios";
const isMobile = window.innerWidth < 900;
const TotalAmountTypography = styled(Typography)`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: ${isMobile ? "14px" : "inherit"};
  bottom: ${isMobile ? "85px" : "70px"};
  right: ${isMobile ? "15px" : "70px"};
`;
const Container = styled.div`
  display: flex;
  // justify-content: space-between;
  align-items: center;
  // margin-bottom: 15px;
  // padding: 10px;
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile ? "100%" : "98%"};
  border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile ? "0px" : "10px"};
  margin-bottom:${isMobile ? "0px" : "10px"};
`;
const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0px;
  }
`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;
const StyledDialog = styled(Dialog)`
  position: relative;
`;
const FabStyle = styled(Fab)`
  && {
    z-index: 1;
  }
`;
const DataGridContainer = styled.div`
  width: 100%;
`;
const DataGridContainer1 = styled.div`
  width: 100%;
  margin-bottom:${!isMobile && "20px"};
 
//   height: 500px;
`;
const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;
const Input = styled.input`
  display: none;
`;
const UserModal = ({ props, onClose, discardModal, remarks, data, id, distributorId, selectedTab }) => {
  const [changePassword, setChangePassword] = useState(false)
  // const [eligibleForDA, setEligibleForDA] = useState(data?.eligible_for_DA == "yes" ? true : false);
  const [eligibleForDA, setEligibleForDA] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const { auth, setAuth } = useContext(AuthContext);
  console.log("DATAAUTH", auth.user.plant_master__c);
  const [dob, setDob] = useState('')
  const [allusers, setAllusers] = useState([])
  const [errors, setErrors] = useState({});
  const [roles, setRoles] = useState([])
  const [plantCode, setPlantCode] = useState("")
  const [loading, setLoading] = useState(false)
  const [product, setProduct] = useState()
  const [dynamicFields, setDynamicFields] = useState(data?.orderDetails?.map((obj, index) => ({ pricebookentryid: '', name: obj.product_name__c, quantity: obj.quantity, unitprice: obj.unitprice, totalprice: obj.totalprice, oid: obj.orderitemnumber, product2id: obj.product2id, id: index + 1 })));
  const [deletedField, setDeletedFields] = useState([])
  const [hasChange, setHasChange] = useState(false);
  const [selectedReportingManager, setSelectedReportingManager] = useState('');
  const detailsRef = useRef();
  const [clusters, setClusters] = useState([])
  const [roleId, setRoleId] = useState([])
  const [open, setOpen] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog1, setOpenDialog1] = useState(false);
  const [reason, setReason] = useState("");
  const [remark, setRemrak] = useState(remarks)
  // ---- Profile picture (Add/Edit Picture) ----
  const [profileImageUrl, setProfileImageUrl] = useState(data?.profileImage || data?.imageUrl || "");
  const [imageUploading, setImageUploading] = useState(false);
  // ---- Joining date ----
  const [joiningDate, setJoiningDate] = useState(data?.doj ? moment.unix(data.doj).format('YYYY/MM/DD') : null);
  const [details, setDetails] = useState({
    "password": "",
    "username": data.username || "",
    "email": data.email || "",
    "name": data.name || "",
    "incentive": data.incentive || "",
    "mobno": data.mobno || "",
    "role": data.role || "",
    "roleId": data.roleId || "",
    "actual_role": data.actual_role || "",
    // "cluster": data.cluster || "",
    "eligible_for_DA": data?.eligible_for_DA || "",
    "cluster": data.cluster ?? "",
    "area": data.area ?? "",
    "dob": data.dob || null,
    "pin": data.pin || "",
    "state": data.state || "",
    "district": data.district || "",
    "AddressLine1": data.AddressLine1 || "",
    "AddressLine2": data.AddressLine1 || "",
    "landmark": data.landmark || "",
    "city": data.city || "",
    "reportingManager": data.reportingManagerName || "",
    "profileImage": data?.profileImage || data?.imageUrl || "",
    "doj": data.doj || null,
  });

  // useEffect(() => {
  //   // if (data?.eligible_for_DA) {
  //   //   setEligibleForDA(data.eligible_for_DA.toLowerCase() == "yes" ? true : false);
  //   // }
  //   if (results?.data?.[0]?.eligible_for_DA) {
  //     setEligibleForDA(results.data[0].eligible_for_DA.toLowerCase() === "yes");
  //   } else {
  //     setEligibleForDA(false);
  //   }

  // }, [data?.eligible_for_DA]);

  console.log(data, "dasasdadasaas", details)
  const getAddress = async (data) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.getUserById(data);
      fetchReportingManagerRole(results.data[0].role)
      // Parse area as array if string
      let userData = { ...results.data[0] };
      if (userData.area && typeof userData.area === "string") {
        try {
          const parsed = JSON.parse(userData.area);
          userData.area = Array.isArray(parsed) ? parsed : [parsed];
        } catch {
          // fallback: try to split by comma
          userData.area = userData.area.split(',').map(x => Number(x.trim())).filter(Boolean);
        }
      }
      setDetails(prev => ({
        ...prev,
        ...userData,
        cluster: details.cluster || userData.cluster || ""
      }));
      if (userData?.eligible_for_DA) {
        setEligibleForDA(userData.eligible_for_DA.toLowerCase() === "yes");
      } else {
        setEligibleForDA(false);
      }
      if (userData?.profileImage || userData?.imageUrl) {
        setProfileImageUrl(userData.profileImage || userData.imageUrl);
      }
      if (userData?.doj) {
        setJoiningDate(moment.unix(userData.doj).format('YYYY/MM/DD'));
      }
      fetchPinCode(userData.Pincode)
      setDob(moment.unix(userData.dob).format('YYYY/MM/DD'));
      setLoading(false)
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }
  useEffect(() => {
    if (data.id) {
      getAddress(data.id);
    }
  }, [])
  const handleChangeTab = (event, newValue) => {
    console.log("newValue: ", newValue);
    setTabValue(newValue);
  };
  const [state, setState] = useState('')
  const [district, setDistrict] = useState('')

  const fetchPinCode = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.fetchPinCode(details);
      console.log("pincode: ", results.data[0].StateName)
      setState(results.data[0].StateName)
      setDistrict(results.data[0].District)
      setLoading(false)
    }
    catch (err) {
      setLoading(false)
    }
  }
  useEffect(() => {
    // fetchPlantCode(distributorId)
    fetchRoles();
  }, [])

  const fetchData = async (details) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.getUserById(details);

      setDetails(results.data[0]);
      setLoading(false)
    }
    catch (err) {
      console.log(err);
      setLoading(false)
    }
  }
  const fetchRoles = async (details) => {
    try {
      setLoading(true);
      let results = await window.Platform.database.fetchRoles(details);
      // Use 'name' as label, 'roleName' as backend value
      const filteredRoles = results.data.map((data) => ({
        roleId: data.roleId,
        roleName: data.roleName,
        roleLabel: data.name,
        hierarchy: data.hierarchy
      }));
      setRoles(filteredRoles.map((data) => data.roleLabel));
      setRoleId(filteredRoles);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const fetchPlantCode = async (data) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.getDepotsForOrder({ distributorSfid: data });
      const plantCode = results?.data?.filter((data) => data.sfid === auth.user.plant_master__c)
      console.log("plantCode", plantCode)
      setPlantCode(plantCode)
      setLoading(false)
    }
    catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
      </GridToolbarContainer>
    );
  }

  const onlyNumeric = (event, type) => {
    if (isNaN(event.target.value)) {
      let mobno, pinCode;
      if (type === "mobile") {
        mobno = event.target.value.replace(/\D/g, "");
        setDetails((prev) => {
          return { ...prev, mobno }
        });
      } else {
        pinCode = event.target.value.replace(/\D/g, "");
        setDetails((prev) => {
          return { ...prev, Pincode: pinCode }
        });
      }
    }
  }

  useEffect(() => {
    getClusterInPicklist()
  }, [])

  const getClusterInPicklist = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getClusterInPicklist();

      if (results && results.status) {
        setClusters(results.data)
      }
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  };

  const calculateTotalPrice = (quantity, unitPrice) => {
    const totalPrice = quantity * unitPrice;
    return isNaN(totalPrice) ? "" : totalPrice;
  };

  const handleQuantityChange = (index, value) => {
    console.log("VALUEE", value)
    const sanitizedValue = value.replace(/[^0-9]/g, '');
    setDynamicFields((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].quantity = sanitizedValue;
      updatedDetails[index].totalprice = sanitizedValue * updatedDetails[index].unitprice
      setHasChanges(true);
      return updatedDetails;
    });
  };

  const handleTextFieldChange = (index, quantity, unit) => {
    const price = calculateTotalPrice(quantity, unit)
    setDynamicFields((prevFields) => {
      const updatedFields = [...prevFields];
      updatedFields[index].totalprice = price;
      return updatedFields;
    });
  };

  const detailUpdate = (key, value) => {
    if (!hasChange) {
      setHasChange(!hasChange);
    }
    var newDetails = { ...details };
    newDetails[key] = value;
    if (key === 'role') {
      let roleIID = roleId.find((val) => val?.roleName === value);
      // If switching to SE/ASM, reset area and keep cluster single
      if (value === 'se' || value === 'asm') {
        newDetails.area = [];
        newDetails.cluster = '';
      } else {
        // If switching to other role, reset cluster and allow multi-area
        newDetails.cluster = '';
        newDetails.area = [];
      }
      setDetails({ ...newDetails, roleId: roleIID?.roleId });
      return;
    }
    setDetails(newDetails);
    if (key === "reportingManager") {
      setDetails({ ...newDetails, reportingManager: value });
      return;
    }
  };

  // // ---- Upload profile picture: calls upload API, stores returned imageURL ----
  // const handleImageUpload = async (event) => {
  //   const file = event.target.files?.[0];
  //   if (!file) return;
  //   try {
  //     setImageUploading(true);
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     // NOTE: rename `uploadUserImage` to match your actual upload API method name
  //     let results = await window.Platform.database.uploadUserImage(formData);
  //     const uploadedUrl = results?.data?.imageURL || results?.imageURL || results?.data?.imageUrl;
  //     if (uploadedUrl) {
  //       setProfileImageUrl(uploadedUrl);
  //       detailUpdate("profileImage", uploadedUrl);
  //       window.NotificationUtils.showSuccess("Image uploaded successfully");
  //     } else {
  //       window.NotificationUtils.showError(results?.message || "Image upload failed");
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     window.NotificationUtils.showError("Image upload failed");
  //   } finally {
  //     setImageUploading(false);
  //     // allow re-selecting the same file again if needed
  //     event.target.value = "";
  //   }
  // };

  // ---- Upload profile picture: calls upload API, stores returned imageURL ----
const handleImageUpload = async (event) => {
  const file = event.target.files?.[0];
  if (!file) return;
  try {
    setImageUploading(true);
    const formData = new FormData();
    formData.append("file", file); 

    const userId = data?.id || details?.id;
    if (userId) {
      formData.append("userId", userId);
    }

    let results = await window.Platform.database.uploadUserImage(formData);
    const uploadedUrl = results?.data?.imageURL || results?.imageURL || results?.data?.imageUrl;
    
    if (uploadedUrl) {
      /* 🌟 यहाँ मुख्य बदलाव है: 
         1. पुराने 'setProfileImageUrl' को हटा दिया गया है।
         2. 'profileImage' की जगह अब 'profileImageUrl' पास किया है ताकि यह तुरंत रेंडर हो सके। */
      detailUpdate("profileImageUrl", uploadedUrl);
      
      window.NotificationUtils.showSuccess("Image uploaded successfully");
    } else {
      window.NotificationUtils.showError(results?.message || "Image upload failed");
    }
  } catch (err) {
    console.log(err);
    window.NotificationUtils.showError("Image upload failed");
  } finally {
    setImageUploading(false);
    event.target.value = "";
  }
};

  // ---- Joining date change handler (mirrors formatDate for DOB) ----
  const formatJoiningDate = (value) => {
    const timestamp = new Date(value.$d);
    const unixTimestamp = Math.floor(timestamp.getTime() / 1000);
    setJoiningDate(value);
    detailUpdate("doj", unixTimestamp);
  };

   const deleteUser = async() => {
    const cleanedRemark = reason.trim().replace(/\s+/g, " ");
    if (!cleanedRemark) {
      window.NotificationUtils.showError("Remark is required.");
      return;
    }
    if (cleanedRemark.length < 20) {
      window.NotificationUtils.showError("Remark must be at least 20 characters long.");
      return;
    }
    console.log(details,"sldhasdjbasdbasjbkjasbjkasbjkasbdbasd")
    // window.confirmationModal(
    //   `Are you sure you want to deactivate ${details.name}  (${details.username})?`,
    //   deleteUser1
    // );
      try {
      setLoading(true);
        const payload = {
          id: details?.id,
          action_remark: reason
        }
    try {
      let results = await window.Platform.database.deleteUser( payload );
      window.NotificationUtils.showSuccess(results?.message || "User Inactive successfully")
      setLoading(false)
      onClose()
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("User Suspension Failed")
      setLoading(false)
    }
  }
  finally {
      setLoading(false);
    }
  };
  
  const deleteUser1 = async () => {
    try {
      setLoading(true)
      console.log("edited User new", { ...details, "state": state, "district": district, id: data.id, reportingManager: details.reportingManager })
      let results = await window.Platform.database.deleteUser({ ...details, "state": state, "district": district, id: data.id, reportingManager: details.reportingManager });
      console.log("RESULTS", results)
      window.NotificationUtils.showSuccess("User deactivated successfully")
      setLoading(false)
      onClose()
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError("User deactivation Failed")
      setLoading(false)
    }
  }

  const handleSelectChange = (index, value) => {
    const unitPrice = product?.filter((data) => (data.name === value))
    setDynamicFields((prevFields) => {
      const updatedFields = [...prevFields];
      updatedFields[index].name = value;
      updatedFields[index].pricebookentryid = unitPrice[0]?.pricebookentryid;
      updatedFields[index].unitprice = unitPrice[0]?.unitprice;
      updatedFields[index].product2id = unitPrice[0]?.product2id
      setHasChanges(true);
      return updatedFields;
    });
  };
  const isLastItemComplete = () => {
    const lastItem = dynamicFields?.[dynamicFields?.length - 1];
    if (lastItem) {
      const isProductComplete = lastItem.product2id !== "" && lastItem.name !== "";
      const isQuantityComplete = lastItem.quantity !== "";
      return isProductComplete && isQuantityComplete;
    } else {
      return true;
    }
  };
  const handleDeleteField = (index) => {
    console.log("DATAAAA", data?.orderDetails)
    setDynamicFields((prevDetails) => {
      const updatedDetails = [...prevDetails];
      const deletedItem = updatedDetails.splice(index, 1)[0]; // Remove the item and store it
      console.log("DELETE", deletedItem)
      setDeletedFields((prevDeletedFields) => [...prevDeletedFields, deletedItem]); // Store in another array
      setHasChanges(true);
      return updatedDetails;
    });
  };
  const remarkOnChange = (value) => {
    setHasChanges(true);
    console.log("REMOVE", value)
    setRemrak(value)
  }
  const fetchReportingManagerRole = async (data) => {
    try {
      setLoading(true)
      const payload = data === "RM" ? "se" : data.toLowerCase();
      let results = await window.Platform.database.fetchReportingManagerRole(payload);
      getUsersOnRole(results.data.results[0].hierarchy)
      setLoading(false)
    }
    catch (err) {
      console.log(err)
      setLoading(false)
    }
  }
  const [reportingUserLabel, setReportingUserLabel] = useState([])
  const getUsersOnRole = async (data) => {
    try {
      setLoading(true)
      let results = await window.Platform.database.getUsersOnRole(data);
      console.log("RESULTS", results)
      setLoading(false)
      setReportingUserLabel(results.data.results)
      setAllusers(results.data.results.map((data) => data.id))
    }
    catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  const validateForm = (data) => {
    const errors = {};
    if (!data.name?.trim()) {
      errors.name = 'Name is required';
    }
    if (!data.username?.trim()) {
      errors.username = 'Username is required';
    }
    if (!data.email?.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = 'Email is invalid';
    }
    if (!data.mobno?.trim()) {
      errors.mobile = 'Mobile is required';
    }
    if (!data.role?.trim()) {
      errors.role = 'Role is required';
    }
    // if (!data.cluster) {
    //   errors.cluster = 'Cluster is required';
    // }
    if (details && (details?.role == "se" || details?.role == "asm")) {
      if (!data.cluster) {
        errors.cluster = 'Area is required';
      }
    }
    else {
      if (data.area && data.area.length === 0) {
        errors.cluster = 'Area is required';
      }

    }
    // if (!data.cluster?.toString().trim()) {
    //   errors.cluster = 'Area is required';
    // }

    if (!data.Pincode?.trim()) {
      errors.pin = 'Pin is required';
    } else if (data.Pincode?.length < 6) {
      errors.pin = 'Pin code must be exactly 6 digits long.';
    }
    if (data.roleId?.trim() !== "WYBlHskzHA") {
      if (!data.reportingManager?.trim()) {
        errors.reportingManager = 'Reporting manager is required';
      }
    }
    return errors;
  };

  const createNewUser = async () => {
    console.log(details, "payloadadaasaaasdasdasdasd")
    try {
      setLoading(true);
      const errors = validateForm(details);
      setErrors(errors);
      if (Object.keys(errors).length === 0) {
        const role1 = details?.role.toUpperCase() === "RM" ? "se" : details?.role.toLowerCase();
        let formattedDetails = {
          ...details,
          role: role1,
          state: state,
          district: district,
          reportingManager: details.reportingManager,
          dob: moment(dob).unix(),
          eligible_for_DA: eligibleForDA ? "yes" : "no",
          profileImage: profileImageUrl,
          doj: details.doj || null,
        };
        // Adjust cluster/area payload based on role
        if (details?.role === "se" || details?.role === "asm") {
          formattedDetails.cluster = details.cluster;
          delete formattedDetails.area;
        } else {
          formattedDetails.area = Array.isArray(details.area) ? details.area : [];
          delete formattedDetails.cluster;
        }
        // console.log("formattedDetails add   <<<<<<<<<<<<<<<<<<<<<<<<<<<<", formattedDetails);
        // setLoading(false);
        // return;
        let results = await window.Platform.database.createNewUser(formattedDetails);
        if (results?.status) {
          window.NotificationUtils.showError(results?.message);
          setLoading(false);
        }
        else {
          window.NotificationUtils.showSuccess("The user has been successfully created.");
          onClose();
          setLoading(false);
        }
      } else {
        window.NotificationUtils.showError("Please make sure to complete all required fields in the form.");
        setLoading(false);
      }
    } catch (err) {
      console.log("Error while creating the user: " + err);
      window.NotificationUtils.showError(err.response?.data?.message || err.message);
      setLoading(false);
    }
  }
  const editUser = async () => {
    try {
      setLoading(true)

      console.log("edited User new", {
        ...details, "state": state, "district": district, id: data.id, reportingManager: details.reportingManager
      }, details
      )
      const errors = validateForm(details);
      setErrors(errors);
      if (Object.keys(errors).length === 0) {
        const role1 = details?.role.toUpperCase() === "RM" ? "se" : details?.role.toLowerCase();
        let formattedDetails = {
          ...details,
          role: role1,
          state: state,
          district: district,
          id: data.id,
          reportingManager: details.reportingManager,
          dob: moment(dob).unix(),
          eligible_for_DA: eligibleForDA ? "yes" : "no",
          profileImage: profileImageUrl,
          doj: details.doj || null,
        };
        // Adjust cluster/area payload based on role
        if (role1 === "se" || role1 === "asm") {
          formattedDetails.cluster = details.cluster;
          delete formattedDetails.area;
        } else {
          formattedDetails.area = Array.isArray(details.area) ? details.area : [];
          delete formattedDetails.cluster;
        }

        // console.log("formattedDetails edit<<<<<<<<<<<<<<<<<<<<<<<<<<<<", formattedDetails);
        // setLoading(false);
        // return;

        let results = await window.Platform.database.editUser(formattedDetails);
        if (results.message === "User already exists") {
          window.NotificationUtils.showError("User already exists");
          setLoading(false);
          return;
        }
        window.NotificationUtils.showSuccess("User updated successfully");
        setLoading(false);
        onClose();
      } else {
        window.NotificationUtils.showError("Please make sure to complete all required fields in the form.");
        setLoading(false);
      }
    }
    catch (err) {
      console.log(err)
      window.NotificationUtils.showError(err.message)
      setLoading(false)
    }
  }
  const activateUser = () => {
    window.confirmationModal(
      `Are you sure you want to activate ${details.name}  (${details.username})?`,
      activateUser1
    );
  };
  const activateUser1 = async () => {
    const cleanedRemark = reason.trim().replace(/\s+/g, " ");
    if (!cleanedRemark) {
      window.NotificationUtils.showError("Remark is required.");
      return;
    }
    if (cleanedRemark.length < 20) {
      window.NotificationUtils.showError("Remark must be at least 20 characters long.");
      return;
    }

    try {
      setLoading(true)
        const payload = {
          id: details?.id,
          action_remark: reason
        }
      let results = await window.Platform.database.activateUser( payload );
      window.NotificationUtils.showSuccess("User activated successfully")
      setLoading(false)
      onClose()
    }
    catch (err) {
      window.NotificationUtils.showError("User activation Failed")
      setLoading(false)
    }
    // window.confirmationModal(
    //   `Are you sure you want to deactivate ${details.name}  (${details.username})?`,
    //   deleteUser1
    // );
  finally {
      setLoading(false);
    }
  }

  const formatDate = (data) => {
    const timestamp = new Date(data.$d);
    const datePickerResponse = new Date(data.$d);
    const year = datePickerResponse.getFullYear();
    const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
    const day = String(datePickerResponse.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const unixTimestamp = Math.floor(timestamp.getTime() / 1000);
    setDob(data)
    detailUpdate("dob", unixTimestamp)
  }

  const renderContent1 = () => {
    return (
      <div style={{ maxHeight: "550px", height: "550px", overflowY: "auto" }}>
        <Stack direction={"row"} spacing={2} padding={2}>
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2} alignItems="center">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: '50%',
                overflow: 'hidden',
                border: '1px solid lightgrey',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
                flexShrink: 0,
              }}
            >
              {(details?.profileImageUrl || data?.profileImageUrl || (Array.isArray(details) ? details[0]?.profileImageUrl : null)) ? (
    <img
      src={details?.profileImageUrl || data?.profileImageUrl || details[0]?.profileImageUrl}
      alt="profile"
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  ) : (
    <Typography variant="caption" color="textSecondary">No Image</Typography>
  )}
            </Box>
            <label htmlFor="profile-image-upload">
              <Input
                id="profile-image-upload"
                type="file"
                accept="image/*"
                disabled={data.status === 0 || selectedTab == 1 || imageUploading}
                onChange={handleImageUpload}
              />
              <Button
                variant="outlined"
                component="span"
                disabled={data.status === 0 || selectedTab == 1 || imageUploading}
                startIcon={imageUploading ? <CircularProgress size={16} /> : null}
              >
                {imageUploading ? "Uploading..." : (profileImageUrl ? "Edit Picture" : "Add Picture")}
              </Button>
            </label>
          </Box>
          <FormControl style={{ width: "100%" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Joining Date"
                type="text"
                fullWidth
                format="YYYY/MM/DD"
                // value={joiningDate ? dayjs(joiningDate) : null}
                value={details.joiningDate ? dayjs(details.joiningDate) : null}
                disabled={data.status === 0 || selectedTab == 1}
                onChange={formatJoiningDate}
                disableFuture={true}
              />
            </LocalizationProvider>
          </FormControl>
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="Name" value={details.name || ""} type="text" fullWidth disabled={data.status === 0 || selectedTab == 1}
            onChange={(e) => detailUpdate("name", e.target.value)}
            required error={errors.name ? true : false}
            inputProps={{ maxLength: 255 }}
          />
          <TextField label="Email" value={details.email || ""} type="text" fullWidth disabled={data.status === 0 || selectedTab == 1}
            onChange={(e) => detailUpdate("email", e.target.value)} required
            error={errors.email ? true : false}
            inputProps={{ maxLength: 255 }}
          />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <TextField disabled={data.status === 0 || selectedTab == 1} label="Mobile" value={details.mobno || ""} type="text" fullWidth onChange={(e) => { detailUpdate("mobno", e.target.value); onlyNumeric(e, "mobile") }} inputProps={{ maxLength: 10 }} required error={errors.mobile ? true : false} />
          </FormControl>
          {/* <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker label="DOJ" type="text" fullWidth format="YYYY/MM/DD" value={dayjs(dob)} disabled={data.status === 0} onChange={(data) => setDob(moment(Number(data)).format('YYYY/MM/DD'))} disableFuture={true} />
            </LocalizationProvider>
          </FormControl> */}
          <FormControl style={{ width: isMobile ? "100%" : "100%" }}>
            <TextField label="Emp ID" type="text" value={details.username || ""} fullWidth disabled={data.status === 0 || selectedTab == 1} onChange={(e) => detailUpdate("username", e.target.value)} required error={errors.username ? true : false} inputProps={{ maxLength: 255 }} />
          </FormControl>
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>

          <TextField label="Address" value={details.AddressLine1 || ""} type="text" fullWidth disabled={data.status === 0 || selectedTab == 1}
            onChange={(e) => detailUpdate("AddressLine1", e.target.value)}
          />
          <TextField label="Pin Code" value={details.Pincode || ""} type="text" fullWidth disabled={data.status === 0 || selectedTab == 1}
            onChange={(e) => {
              if (e.target.value.length === 6) {
                fetchPinCode(e.target.value)
              }
              detailUpdate("Pincode", e.target.value);
              onlyNumeric(e, "pin");
            }
            }
            required
            error={errors.pin ? true : false}
            inputProps={{ maxLength: 6 }}
          />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          {/* <TextField label="Pin Code" value={details.Pincode || ""} type="text" fullWidth disabled={data.status === 0}
            onChange={(e) => {
              if (e.target.value.length === 6) {
                fetchPinCode(e.target.value)
              }
              detailUpdate("Pincode", e.target.value);
              onlyNumeric(e, "pin");
            }
            }
            required
            error={errors.pin ? true : false}
            inputProps={{ maxLength: 6 }}
          /> */}
          <TextField label="State" value={state || ""} type="text" fullWidth disabled onChange={(e) => setState(e.target.value)} />
          <TextField label="District" value={district || ""} type="text" fullWidth disabled onChange={(e) => setDistrict(e.target.value)} />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          {/* <TextField label="District" value={district || ""} type="text" fullWidth disabled onChange={(e) => setDistrict(e.target.value)} /> */}
          {/* <TextField label="Landmark" value={details?.Landmark || ""} type="text" fullWidth disabled={data.status === 0}
            onChange={(e) => detailUpdate("Landmark", e.target.value)} inputProps={{ maxLength: 255 }} /> */}
          <TextField label="Posted City" value={details?.city || ""} type="text" fullWidth disabled={data.status === 0 || selectedTab == 1}
            onChange={(e) => detailUpdate("city", e.target.value)} inputProps={{ maxLength: 255 }} />

          <Autocomplete
            disabled={data.status === 0 || selectedTab == 1}
            options={roleId.map(r => r.roleLabel)}
            style={{ width: "100%" }}
            value={(() => {
              if (!details?.role) return "";
              // Find the label from roleId state by matching roleName
              const found = roleId.find(r => r.roleName && r.roleName.toLowerCase() === details.role.toLowerCase());
              return found ? found.roleLabel : details.role;
            })()}
            getOptionLabel={option => option}
            onChange={async (e, value) => {
              // Find the backend value from roleId state by label
              const found = roleId.find(r => r.roleLabel === value);
              let backendRole = found ? found.roleName : value.toLowerCase();
              detailUpdate("role", backendRole);
              fetchReportingManagerRole(backendRole);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={"Assigned Role"}
                required
                variant="outlined"
                error={errors.role ? true : false}
              />
            )}
          />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          {details && (details?.role == "se" || details?.role == "asm") ? <FormControl variant="outlined" fullWidth>{console.log(errors, "ERRORS")}
            <InputLabel style={{ background: "white" }} required error={errors.cluster ? true : false} disabled={data.status === 0 || selectedTab == 1}>Select Area</InputLabel>
            <Select labelId="Cluster" label="Select Area" value={details.cluster} onChange={(e) => detailUpdate("cluster", e.target.value)} required error={errors.cluster ? true : false} disabled={data.status === 0 || selectedTab == 1}>
              {clusters?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
            :
            <div style={{ position: "relative", width: "100%" }}>
              {/* Fake Dropdown Input */}
              <div
                onClick={() => setOpen(!open)}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: "10px 12px",
                  background: "#fff",
                  cursor: data.status === 0 ? "not-allowed" : "pointer",
                  color: details.area?.length ? "#000" : "#888",
                }}
              >
                {details.area?.length
                  ? `${details.area.length} area(s) selected`
                  : "Select Area"}
              </div>

              {data?.status != 0 && open && (
                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: 6,
                    padding: 12,
                    background: "#fafafa",
                    marginTop: 4,
                    position: "absolute",
                    width: "100%",
                    zIndex: 1000,
                    maxHeight: 400,
                    overflowY: "auto",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 8, // spacing between items
                  }}
                >
                  <div style={{ flexBasis: "100%" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={details.area?.length === clusters.length && clusters.length > 0}
                          indeterminate={
                            details.area?.length > 0 &&
                            details.area?.length < clusters.length
                          }
                          onChange={(_, checked) => {
                            detailUpdate(
                              "area",
                              checked ? clusters.map((c) => c.id) : []
                            );
                          }}
                        />
                      }
                      label="Select All"
                    />
                  </div>

                  {clusters.map((option) => (
                    <div key={option.id} style={{ flexBasis: "45%" }}>
                      {/* 45% width → 2 per row, 30% → 3 per row */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={details.area?.includes(option.id)}
                            onChange={(_, checked) => {
                              let newArea = checked
                                ? [...(details.area || []), option.id]
                                : (details.area || []).filter((id) => id !== option.id);
                              detailUpdate("area", newArea);
                            }}
                          />
                        }
                        label={option.name}
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          }
        </Stack>
      </div>
    )
  }

  const renderContent = (params) => {
    console.log("CheckTeabRenderContent", tabValue)
    return (
      <div style={{ maxHeight: "550px", height: "550px", overflowY: "auto" }}>
        <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="USER Name" type="text" value={details.username || ""} fullWidth disabled inputProps={{ maxLength: 255 }} />
          <Autocomplete
            disabled
            options={roleId.map(r => r.roleLabel)}
            style={{ width: "100%" }}
            value={(() => {
              if (!details?.role) return "";
              // Find the label from roleId state by matching roleName
              const found = roleId.find(r => r.roleName && r.roleName.toLowerCase() === details.role.toLowerCase());
              return found ? found.roleLabel : details.role;
            })()}
            getOptionLabel={option => option}
            onChange={async (e, value) => {
              // Find the backend value from roleId state by label
              const found = roleId.find(r => r.roleLabel === value);
              let backendRole = found ? found.roleName : value.toLowerCase();
              detailUpdate("role", backendRole);
              fetchReportingManagerRole(backendRole);
            }}
            renderInput={(params) => (
              <TextField
                disabled
                {...params}
                label={"Assigned Role"}
                required
                variant="outlined"
                error={errors.role ? true : false}
              />
            )}
          />
        </Stack>
        <Stack direction={"row"} spacing={2} padding={2}>
          <TextField label="Actual Role" value={details.actual_role || ""} type="text" fullWidth onChange={(e) => detailUpdate("actual_role", e.target.value)} disabled = {data.status === 0 || selectedTab == 1} />
          {/* <TextField label="Target for the Incentive" type="text" value={details.incentive || ""} fullWidth disabled={data.status === 0} onChange={(e) => detailUpdate("incentive", e.target.value)} /> */}
          <FormControl fullWidth variant="outlined">
            <InputLabel required={details?.role.toLowerCase() !== "super admin"}>Reporting Manager</InputLabel>
            <Select
              value={details.reportingManager || data.reportingManager || ''}
              disabled={data.status === 0 || selectedTab == 1}
              onChange={(event) => {
                const selectedOption = event.target.value;
                console.log("selectedOption", selectedOption);
                detailUpdate("reportingManager", selectedOption);
              }}
              label="Reporting Manager"
              required
              error={errors.reportingManager}
            >
              {allusers.map((user) => {
                const manager = reportingUserLabel.find(member => member.id === user);
                return (
                  <MenuItem key={user} value={user}>
                    {manager ? manager.name : user}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Stack >
        <Stack direction={"row"} spacing={2} padding={2}>
          <FormControl fullWidth>{console.log(eligibleForDA, "eligibleForDA")}
            <FormControlLabel disabled={data.status === 0 || selectedTab == 1}
              control={
                <Checkbox disabled={data.status === 0 || selectedTab == 1}
                  checked={eligibleForDA}
                  onChange={(e) => { detailUpdate("eligible_for_DA", e.target.checked); setEligibleForDA(e.target.checked) }}
                />
              }
              label="Eligible for DA"
            />
          </FormControl>
        </Stack>
        <Stack direction={"row"} padding={1}>
          {
            (data.id && data.status != 0 && selectedTab != 1)
            &&
            <Container>
              <Checkbox variant="contained" value={changePassword} onChange={(e) => {
                if (!changePassword === false) {
                  const newState = { ...details };
                  delete newState.password;
                  setDetails(newState);
                }
                setChangePassword(!changePassword)
              }} />
              <Typography variant="contained">Check this to change password</Typography>
            </Container>
          }
          {
            !data.id
            &&
            <Stack style={{ width: '100%' }} direction={"row"} spacing={2} padding={1}>
              <TextField type="password" label="Password" value={details.password || ""}
                fullWidth onChange={(e) => detailUpdate("password", e.target.value)}
                disabled={changePassword}
              />
            </Stack>
          }
        </Stack>
        {data.id && changePassword && <Stack direction={"row"} spacing={2} padding={2}>

          <TextField label="New Password" value={details.password || ""} type="password" fullWidth onChange={(e) => detailUpdate("password", e.target.value)} />
        </Stack>}
       {selectedTab == 1 ?
       <div style={{ position: 'absolute', bottom: '20px', left: '50%', transform: 'translate(-50%, -50%)' }}>
          <Button sx={{ marginLeft: '10px' }} variant="contained" onClick={()=>setOpenDialog1(true)}>
              Activate User
            </Button>
            <Button sx={{ marginLeft: '10px' }} variant="contained" onClick={() => setOpenDialog(true)}>
              Inactivate
            </Button>
       </div>
       :
       <div style={{ position: 'absolute', bottom: '20px', left: '50%', transform: 'translate(-50%, -50%)' }}>
          {data.status !== 0 && <>
            <Button variant="contained" onClick={() => {
              if (data.id) {
                editUser()
                console.log("aaaaaa")
              }
              else {
                createNewUser()
              }
            }
            } >
              {data.id ? 'Update' : 'Create'}
            </Button>
            {data.id && <Button sx={{ marginLeft: '10px' }} variant="contained" onClick={() => setOpenDialog(true)}>
              Inactivate
            </Button>}
          </>}
          {
            data.status === 0
            &&
            <Button sx={{ marginLeft: '10px' }} variant="contained" onClick={()=>setOpenDialog1(true)}>
              Activate User
            </Button>
          }
        </div>}
      </div>
    );
  };
  return (
   <>
    <Dialog disableEnforceFocus maxWidth="lg" fullWidth={true} open={true} >
      {loading && <OpaqueLoading />}
      <ModalHeaderContainer style={{ marginBottom: 1, paddingBottom: 3 }}>
        <Typography variant={isMobile ? "h6" : "h5"}>
          {data.id ? 'Edit User' : 'Add User'}
          <Tooltip title="Order Id">
            {id}
          </Tooltip>
        </Typography>
        <IconButton onClick={discardModal} >
          <CloseOutlined />
        </IconButton>
      </ModalHeaderContainer>
      <TableContainer>
        <TabsContainer>
          <StyledTabs
            variant="fullWidth"
            value={tabValue}
            onChange={handleChangeTab}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Personal Details" />
            <Tab label="User Credentials" />
          </StyledTabs>
          {tabValue == 1 ? renderContent() : renderContent1()}
        </TabsContainer>
        </TableContainer>
      </Dialog>
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>InActive User</DialogTitle>
        <DialogContent>
          User Name :- {data ? data.name + " - " + data.username : "N/A"}
          <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={()=>{deleteUser()}} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openDialog1} onClose={() => setOpenDialog1(false)} fullWidth>
        <DialogTitle>Activate User</DialogTitle>
        <DialogContent>
          User Name :- {data ? data.name + " - " + data.username : "N/A"}
          <TextField autoFocus margin="dense" label="Remark" type="text" fullWidth variant="outlined" value={reason} onChange={(e) => setReason(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog1(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={()=>{activateUser1()}} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserModal;